import { ResponseBase } from './commons';

export const enum EnumCoverMinileagues {
  Prize = 'PRIZE',
  Winner = 'WINNNER',
  NotWinner = 'NOT_WINNNER',
  NoParticipate = 'NO_PARTICIPE',
  Classified = 'CLASSIFIED',
  NotClassified = 'NOT_CLASSIFIED',
  PassFinal = 'PASS_FINAL',
  Consult = 'CONSULT',
  InProgress = 'IN_PROGRESS',

  FinalEnd = 'FINAL_END',

  FinalClassified = 'FINAL_CLASSIFIED',
  FinalWinner = 'FINAL_WINNER',
  FinalPlayerNotClassified = 'FINAL_PLAYER_NOT_CLASSIFIED',
  FinalPlayerNotParticipating = 'FINAL_PLAYER_NOT_PARTICIPATING',

  FirstMale = 'FirstMale',
  SecondMale = 'SecondMale',
  ThirdMale = 'ThirdMale',
  FourthMale = 'FourthMale',
  FifthMale = 'FifthMale',
  FirstFemale = 'FirstFemale',
  SecondFemale = 'SecondFemale',
  ThirdFemale = 'ThirdFemale',
  FourthFemale = 'FourthFemale',
  FifthFemale = 'FifthFemale',

  NoTop5 = 'NoTop5',
  NotParticipatedOrNotClassified = 'NotParticipatedOrNotClassified',
}

export const enum EnumCoverGoldDate {
  Winner = 'WINNNER',
  Default = 'DEFAULT',
}

export type FechaMiniLigaTO = {
  /**
   * Format: int32
   * @description id de 'FechaMiniLiga' (no de Fecha)
   */
  id?: number;
  /**
   * Format: int32
   * @description orden de Fecha, no de 'FechaMiniLiga' (no comienza desde 0)
   */
  ordF?: number;
  /**
   * Format: byte
   * @description id de estado.<li>1: no publicada</li><li>2:publicada resultado,</li> <li>3: (solo desenlace) publicada, estado que toma en desenlace al publicar la fecha desenlace.</li>
   */
  idE?: string;
  nF?: string;
  nf?: string;
  /** @enum {string} */
  estado?: 'NO PUBLICADA' | 'PUBLICADA RESULTADO' | 'PUBLICADA';
};

export type UsuarioDTReducidoTO = {
  /**
   * Format: int32
   * @description obvio
   */
  idUsuario?: number;
  /** @description obvio */
  nombres?: string;
  /** @description obvio */
  apellido?: string;
  /** @description obvio */
  club?: string;
  /** @description obvio */
  provincia?: string;
  /** @description obvio */
  nombreEquipo?: string;
  /**
   * Format: int32
   * @description obvio
   */
  edad?: number;
  /**
   * Format: int32
   * @description (sólo búsquedas, no viene en sugerencias) <br>idEstado cambia según sea ML/TDA/GCA. <br><br>Estados TDA: idEstado/nombreEstado en TDA. <br> <b>idEstado es correcto, nombreEstado sólo usable en TDA</b><br> Viene de EEstadoParticipanteTorneoAmigos  	<li> 0 o undefined: estado inexistente (no participa en el TDA) </li> 	<li> PENDIENTE_ACEPTAR_DUENIO( 1, "Pendiente Aceptar Dueño"),</li> 	<li>PARTICIPANDO( 2, "Participando"),</li> 	<li>ELIMINADO( 3, "Eliminado"), </li>	<li>PENDIENTE_ACEPTAR_INVITADO( 4, "Pendiente Aceptar Invitado"), </li>	<li>RECHAZADO( 5, "rechazado por el dueño"), </li>	<li>RECHAZA_INVITADO( 6, "Invitación rechazada por Invitado")</li><br>Estados  ML: <br> idEstado para ML:<li>PENDIENTE_ACEPTAR_DUENIO((byte)1, "Pendiente Aceptar Dueño")</li> <li>PARTICIPANDO((byte)2, "Participando")</li> <li>ELIMINADO((byte)3, "Eliminado")</li> <li>RECHAZADO((byte)4,"Invitación rechazada")</li> <li>PENDIENTE_ACEPTAR_INVITADO((byte)5, "Pendiente Aceptar Invitado")</li> <li>RECHAZA_INVITADO((byte)6,"Invitación rechazada por Invitado")</li><br>Estados GCA: idEstado para GCA es igual a ML.
   */
  idEstado?: number;
  /** @description <br>Este campo sólo es usable para TDA <br>idEstado/nombreEstado en TDA. <br> <b>idEstado es correcto, nombreEstado sólo usable en TDA</b><br> Viene de EEstadoParticipanteTorneoAmigos  	<li> 0 o undefined: estado inexistente (no participa en el TDA) </li> 	<li> PENDIENTE_ACEPTAR_DUENIO( 1, "Pendiente Aceptar Dueño"),</li> 	<li>PARTICIPANDO( 2, "Participando"),</li> 	<li>ELIMINADO( 3, "Eliminado"), </li>	<li>PENDIENTE_ACEPTAR_INVITADO( 4, "Pendiente Aceptar Invitado"), </li>	<li>RECHAZADO( 5, "rechazado por el dueño"), </li>	<li>RECHAZA_INVITADO( 6, "Invitación rechazada por Invitado")</li> */
  nombreEstado?: string;
  /**
   * @description String (CSV) para representar la camiseta
   * @example 3,4,e92121,ab1414,3
   */
  camiseta?: string;
  /** @description obvio */
  localidad?: string;
  /** @description url a foto de perfil */
  fotoPerfil?: string;
  /** Format: int32 */
  id?: number;
};

export type DatosParticipanteMiniLigasGDTTO = {
  n?: string;
  a?: string;
  /** Format: int32 */
  posG?: number;
  /** Format: int32 */
  idUsuario?: number;
  /** Format: int32 */
  idTipoDocumento?: number;
  /** Format: int32 */
  nroDoc?: number;
  descalificado?: boolean;
  fotoPerfil?: string;
};

export type DatosParticipanteMiniLigasTO = {
  /**
   * Format: int32
   * @description id de participante
   */
  id?: number;
  /**
   * Format: int32
   * @description partidos jugados (T_POS_TABLA_ML)
   */
  pj?: number;
  /**
   * Format: int32
   * @description partidos ganados (T_POS_TABLA_ML)
   */
  pg?: number;
  /**
   * Format: int32
   * @description partidos empatados (T_POS_TABLA_ML)
   */
  pe?: number;
  /**
   * Format: int32
   * @description partidos perdidos (T_POS_TABLA_ML)
   */
  pp?: number;
  /**
   * Format: int32
   * @description puntos (tabla de miniligas) (T_POS_TABLA_ML)
   */
  pts?: number;
  /**
   * Format: int32
   * @description posicion en fecha (rnk común)
   */
  posGral?: number;
  /**
   * Format: int32
   * @description posición en tabla de miniligas (T_POS_TABLA_ML)
   */
  pos?: number;
  part?: DatosParticipanteMiniLigasGDTTO;
  /** @description Nombre provincia */
  p?: string;
  /** @description hincha de (club) */
  hd?: string;
  /** @description hincha de (otro) */
  hdo?: string;
  /** @description Nombre de equipo */
  ne?: string;
  /** @description String del escudo */
  e?: string;
  /** @description String del camiseta */
  c?: string;
  /** @description localidad */
  l?: string;
  /**
   * Format: byte
   * @description <br> idEstado para ML:<li>PENDIENTE_ACEPTAR_DUENIO((byte)1, "Pendiente Aceptar Dueño")</li> <li>PARTICIPANDO((byte)2, "Participando")</li> <li>ELIMINADO((byte)3, "Eliminado")</li> <li>RECHAZADO((byte)4,"Invitación rechazada")</li> <li>PENDIENTE_ACEPTAR_INVITADO((byte)5, "Pendiente Aceptar Invitado")</li> <li>RECHAZA_INVITADO((byte)6,"Invitación rechazada por Invitado")</li>
   */
  idEstadoParticipacion?: string;
  /**
   * Format: date-time
   * @description last update del registro
   */
  fechaActualizacion?: string;
  /** @description obvio */
  fotoPerfil?: string;
  camiSvg?: string;
};

export type PartidoMiniLigaTO = {
  /**
   * Format: int32
   * @description El id del partido
   */
  id?: number;
  /**
   * Format: int32
   * @description Id del participante 1
   */
  idP1?: number;
  /**
   * Format: int32
   * @description Id del participante 2
   */
  idP2?: number;
  p1?: DatosParticipanteMiniLigasTO;
  p2?: DatosParticipanteMiniLigasTO;
  /**
   * Format: int32
   * @description (si fecha publicada resultado) puntos participante 1
   */
  ptsP1?: number;
  /**
   * Format: int32
   * @description (si fecha publicada resultado) puntos participante 2
   */
  ptsP2?: number;
  fechaML?: FechaMiniLigaTO;
};

export type ResponseInitMiniligas = {
  /**
   * true / false.
   * @description Indica si hubo un error o no.
   */
  estado: boolean;
  /**
   * mensaje de error
   * @description si estado == false.
   */
  mensaje?: string;
  /**
   * código de error (opcional)
   * Format: int32
   * @description si estado == false.
   */
  codError?: number;
  /** @description True si se encuentran configuradas las MiniLigas y ya se encuentra en la etapa de Desenlace */
  confDesenlace?: boolean;
  /** @description (para desktop, ignorar) */
  salida?: string;
  /** @description True si se encuentran configuradas las MiniLigas */
  confML?: boolean;
  /** @description No están configuradas la ML.(mostrar una prehome) */
  noExisteConfML?: boolean;
  /**
   * @description (Precondición: No están configuradas la ML)  En esta prehome se muestra algo como  'Comenzás a jugar en la fecha XX, (martes x de enero)'
   * @example Fecha 8
   */
  noExisteConfML_competisDesde?: string;
  /**
   * @description (Precondición: No están configuradas la ML)  En esta prehome se muestra algo como  'Comenzás a jugar en la fecha XX, (martes x de enero)'
   * @example martes 8 de agosto
   */
  noExisteConfML_teAnotasDesde?: string;

  ordenFechaPrimerEquipoUsuario?: number;

  /**
   * Format: int32
   * @description (Precondición: están configuradas la ML)  Orden de la primera fecha de ML.
   */
  ordenPrimeraFechaML?: number;
  /** @description True si participa en MiniLigas */
  participa?: boolean;
  /**
   * Format: int32
   * @description cantidad de MLs de la edición anterior que el usuario logueado tiene pendiente por activar.
   */
  cantMLAnt?: number;
  /** @description (Precondición: están configuradas la ML)  Nombre de la primera fecha de ML. */
  nombrePrimeraFechaML?: string;
  /**
   * Format: int32
   * @description Cantidad de participantes de ML (cant fechas + 1)
   */
  cantPartMaxXML?: number;
  /** @description <li>"true" si comenzó la Etapa de Competencia.</li><li>"false", si se encuentra en la Etapa de Registración.</li> */
  comenzaron?: boolean;
  /** @description el usuario tiene invitaciones Pendientes? */
  tienePendientes?: boolean;
  /**
   * @description (probablemente innecesario) 'titulo y mensajeTxt' son dos textos para mostrar. Hoy sólo se muestran si  'comenzaron' == true y 'participa' == false)
   * @example Ya se están jugando desde la Fecha 8
   */
  titulo?: string;
  /**
   * @description (probablemente innecesario) 'titulo y mensajeTxt' son dos textos para mostrar. Hoy sólo se muestran si  'comenzaron' == true y 'participa' == false)
   * @example Lamentablemente no podés participar
   */
  mensajeTxt?: string;
  /** @description True si participa del desenlace de MiniLigas */
  participaDesenlace?: boolean;
  /** @description idem nombrePrimeraFechaML, pero mal escrito */
  nombrePrimerFecha?: string;
  /** @description última fecha de ML */
  nombreUltimaFecha?: string;
  /** @description fecha de desenlace de ML */
  nombreFechaDesenlace?: string;
};

export type ResponseInitDesenlaceMl = {
  /**
   * true / false.
   * @description Indica si hubo un error o no.
   */
  estado: boolean;
  /**
   * mensaje de error
   * @description si estado == false.
   */
  mensaje?: string;
  /**
   * código de error (opcional)
   * Format: int32
   * @description si estado == false.
   */
  codError?: number;
  /** @description redundante. obvio. */
  nombreUsuario?: string;
  /** @description <LI>"false", si no se encuentra Publicada Resultado</LI><LI>"true" si se encuentra Publicada Resultado.</LI> */
  publicadaResultado?: boolean;
  /** @description "true" si fue descalificado en la etapa de desenlace */
  descalificado?: boolean;
  /**
   * Format: int32
   * @description Puntos Del usuario en la fecha configurada como Desenlace
   */
  puntosDesenlace?: number;
  /**
   * Format: int32
   * @description puesto del usuario en el Desenlace de Mini Ligas, Si participaDesenlace = true y PublicadaResultado= true
   */
  puestoDesenlace?: number;
  /**
   * evitar usar esto
   * @deprecated
   * @description redundante y mal nombrado. <br>puestoDesenlace > 1 y puestoDesenlace<=10. NOTAR que el ganador da false.
   */
  top10?: boolean;
  /**
   * es el ganador
   * @description (precondición: publicadaResultado=true y participaDesenlace=true)<br>equivalente a: puestoDesenlace == 1 && !descalificado
   */
  gano?: boolean;
  /** @description llegó al desenlace (ganó su miniliga) */
  participaDesenlace?: boolean;
  /** @description participó en la etapa de competencia (cuidado: puede no participar en el desenlace si no ganó su ML) */
  participaML?: boolean;
  /**
   * Format: int32
   * @description fecha del desenlace. ORDEN.
   */
  ordenFecha?: number;
  /**
   * Format: int32
   * @description fecha del desenlace. id. Usar para cargar '/ganadores/ganadores_desenlace_ml_${idFechaDes}.json'
   */
  idFechaDes?: number;
  /** @description fecha del desenlace. Nombre. */
  nombreFechaDesenlace?: string;
  /** @description premios de puesto 1 a 5. (enteros, formatear) */
  premios?: number[];
  /** @description Link 'Volver a Mis Miniligas'. A veces lo pide Marketing para evitar reclamos 	(ej: se recalculó la fecha 24 de GDT33, y no quieren andar explicando que los partidos postergados no cuentan para ML)  */
  deboOcultarLinkVerMisMiniligas?: boolean;
};

export type ParticipanteFinalMlTO = {
  id: number;
  nombre: string;
  apellido: string;
  nombreEquipo: string;
  edad: string;
  hinchaDe: string;
  puesto: number;
  puntos: number;
  tipoDocumento: number;
  telefono: string;
  provincia: string;
  descalificado: boolean;
};

export type ResponseFinalWinnersMl = {
  estado: boolean;
  mensaje?: string;
  codError?: number;
  ganadores?: ParticipanteFinalMlTO[];
};

export type ResponseFinalWinnersMlFallback = ParticipanteFinalMlTO[];

export type MiniLigasTO = {
  [x: string]: any;
  length: number;
  /** Format: int32 */
  id?: number;
  nombreML?: string;
  /**
   * Format: int32
   * @description id del dueño
   */
  idUsuarioOwner?: number;
  /** @description partidos */
  parts?: PartidoMiniLigaTO[];
  /** @description participantes */
  partis?: DatosParticipanteMiniLigasTO[];
  /** @description fechas */
  fs?: FechaMiniLigaTO[];
  /**
   * Format: int32
   * @description obvio
   */
  cantidadParticipantes?: number;
  /**
   * Format: byte
   * @description <li>INCOMPLETA((byte)1, "Incompleta"),</li> <li>COMPLETA((byte)2, "Completa");</li>
   */
  idEstadoML?: number;
  idEstadoParticipacion?: number;
  /** @description nombre del administrador */
  nombreAdm?: string;
  /** @description apellido del administrador */
  apellidoAdm?: string;
  owner?: boolean;
  isOwner?: boolean;
  fechaOrdenFecha?: FechaMiniLigaTO[];
  provinciaAdm?: string;
};

export type ResponseListPendingML = {
  estado: boolean;
  codError?: number;
  mensaje?: string;
  misMiniLigas: MiniLigasTO[];
  misMiniLigasPostuladas: MiniLigasTO[];
};

export type ResponseListParticipatingML = {
  estado: boolean;
  mensaje?: string;
  misMiniLigas: MiniLigasTO[];
  cantPartMaxXML: number;
  cantMLAnt?: number;
  nombrePrimerFecha: string;
  nombreUltimaFecha: string;
  nombreFechaDesenlace: string;
};

export type ResponseListPreviousMl = {
  estado: boolean;
  mensaje?: string;
  miniLigasAnt: MiniLigasTO[];
};

export type ResponseCreateML = {
  estado: boolean;
  mensaje?: string;
  miniLiga: MiniLigasTO;
};

export type ResponseSugerirMl = {
  /**
   * true / false.
   * @description Indica si hubo un error o no.
   */
  estado: boolean;
  /**
   * mensaje de error
   * @description si estado == false.
   */
  mensaje?: string;
  /**
   * código de error (opcional)
   * Format: int32
   * @description si estado == false.
   */
  codError?: number;
  miniLigasSugeridas?: MiniLigasTO[];
};

export type ResponsePostulationMl = {
  estado: boolean;
  mensaje?: string;
  codError?: number;
};

export type RequestManagePostulantML = {
  tipoAccion: number;
  idMiniLiga: number;
  idParticipante?: number;
  idUsuario?: number;
};

export type ResponseManagePostulantMl = {
  estado: boolean;
  mensaje?: string;
  miniLiga?: MiniLigasTO;
  codError?: number;
};

export type ResponseListParticipatingMinileague = {
  estado: boolean;
  mensaje?: string;
  codError?: number;
  /** ID del dueño de la MiniLiga */
  idOwnerML?: number;
  /** Nombre de la MiniLiga */
  nombreML?: string;
  /** Participantes pendientes de aceptación en la MiniLiga */
  miniLigaPartPend?: DatosParticipanteMiniLigasTO[];
  /** Participantes activos en la MiniLiga */
  miniLigaParticipantes?: DatosParticipanteMiniLigasTO[];
};

export type ResponseBasicDataMinileague = {
  estado: boolean;
  nombre?: string;
  nombreDuenio?: string;
  apellidoDuenio?: string;
  fechaInicio?: FechaMiniLigaTO;
  idEstadoParticipante?: number;
  idMiniLiga?: number;
  idOwnerML?: number;
};

export type RequestMiniliguesSearch = {
  nombreMiniLiga?: string;
  nombreDueno?: string;
  apellidoDueno?: string;
  paginaActual?: number;
  cantPorPagina?: number;
};

export type PagerInfo = {
  /** Format: int32 */
  length?: number;
  /** Format: int32 */
  init?: number;
};

export type PageMiniLigasTO = {
  objectList?: MiniLigasTO[];
  /** Format: int32 */
  pageCount?: number;
  /** Format: int32 */
  currentPage?: number;
  hasNext?: boolean;
  hasPrevious?: boolean;
  pagerInfo?: PagerInfo;
  /** Format: int32 */
  objectCount?: number;
};

export type ResponseBuscarML = {
  /**
   * true / false.
   * @description Indica si hubo un error o no.
   */
  estado: boolean;
  /**
   * mensaje de error
   * @description si estado == false.
   */
  mensaje?: string;
  /**
   * código de error (opcional)
   * Format: int32
   * @description si estado == false.
   */
  codError?: number;
  page?: PageMiniLigasTO;
  /** Format: int32 */
  paginaActual?: number;
  /** Format: int32 */
  cantPorPagina?: number;
  nombreML?: string;
  nombreDueno?: string;
  apellidoDueno?: string;
};
/** @description Info del usuario para usar en menciones */
export interface MentionTO {
  /** @description id de usuarioDT (no de participante). Viene como string, pero es integer. */
  uid?: string;
  /** @description nombre y apellido */
  value?: string;
  /** @description Algo así como nombre y apellido, recortado */
  displayName?: string;
  /** @description camiseta */
  camiseta?: string;
}

export type RequestMiniliguesBuscarDT = {
  idML: number;
  nombre?: string;
  apellido?: string;
  idlocalidad?: number;
  idPartido?: number;
  idProvincia?: number;
};

export interface ResponseVerML {
  /**
   * true / false.
   * @description Indica si hubo un error o no.
   */
  estado: boolean;
  /**
   * mensaje de error
   * @description si estado == false.
   */
  mensaje?: string;
  /**
   * código de error (opcional)
   * Format: int32
   * @description si estado == false.
   */
  codError?: number;
  /**
   * Format: int32
   * @description Orden de la última fecha con puntos (estado == PUBLICADA_RESULTADO), o primera
   */
  ordenFechaMiniligaActualParaPuntos?: number;
  /** @description true, Si corresponde a la última fecha de la competencia de ML. */
  ultimaFecha?: boolean;
  /** @description true, Si corresponde a la última fecha de la competencia ML y si el usuario logueado es el ganador de la ML. */
  esganador?: boolean;
  /** @description la fecha (ordenFechaMiniligaActualParaPuntos) está en veda */
  veda?: boolean;
  /**
   * Format: int32
   * @description Seleccioná esta fecha para mostrar los partidos. <br>usualmente 'ordenFechaMiniligaActualParaPuntos', pero si la siguiente ya entró en veda devuelve la siguiente (y muestra los partidos sin puntos)
   */
  ordenFechaMiniligaActual?: number;
  /**
   * @description estado de la fecha 'actual' (ver ordenFechaMiniligaActual)
   * @enum {string}
   */
  estadoFechaMiniligaActual?: 'PUBLICADA_RESULTADO' | 'NO_PUBLICADA';
  miniliga?: MiniLigasTO;
  /** @description Map 'orden fecha ML (desde cero)' -> 'lista de partidos' */
  partidosFecha?: {
    [key: string]: PartidoMiniLigaTO[];
  };
  /** @description lista de FechaMiniLigaTO, ordenada por orden (ordF) */
  fechasMiniLiga?: FechaMiniLigaTO[];
  /** @description (¿igual a fechasMiniLiga?) lista de FechaMiniLigaTO, ordenada por orden (ordF) */
  fechasConfML?: FechaMiniLigaTO[];
  /**
   * Format: int32
   * @description id de participante de ML del usuario logueado
   */
  idUsuarioML?: number;
  /** @description redundancia de 'estado' */
  status?: boolean;
  /**
   * Format: int32
   * @description id del usuario logueado
   */
  idUsuario?: number;
  /** @description data de usuarios, para usar en las menciones del chat (formato LISTA) */
  dataChat?: MentionTO[];
  /** @description idem dataChat (formato: Map) */
  dataChat2?: { [key: string]: MentionTO };
}

export interface PosicionTO {
  /**
   * Format: int32
   * @description 1=arq.., 4=del
   * @enum {integer}
   */
  id?: 1 | 2 | 3 | 4;
  /**
   * @description Nombre completo
   * @enum {string}
   */
  nombre?: 'Arquero' | 'Defensor' | 'Volante' | 'Delantero';
  /**
   * @description Nombre corto
   * @enum {string}
   */
  nombreCorto?: 'ARQ' | 'DEF' | 'VOL' | 'DEL';
  /**
   * Format: int32
   * @description ?
   */
  orden?: number;
}

export interface JugadorMiniLigaTO {
  /**
   * Format: int32
   * @description obvio
   */
  id?: number;
  /** @description obvio */
  nombres?: string;
  /** @description obvio */
  apellido?: string;
  posicion?: PosicionTO;
  /** @description obvio */
  nombreCompleto?: string;
  /**
   * @description color del status del jugador (RGB)
   * @example FF0000
   */
  status?: string;
  /** @description obvio */
  capitan?: boolean;
  /** @deprecated */
  nombreEquipo?: string;
}

export interface ResponseVerEquiposML {
  /**
   * true / false.
   * @description Indica si hubo un error o no.
   */
  estado: boolean;
  /**
   * mensaje de error
   * @description si estado == false.
   */
  mensaje?: string;
  /**
   * código de error (opcional)
   * Format: int32
   * @description si estado == false.
   */
  codError?: number;
  /** @description Equipo del usuario logueado */
  equipoPropio?: JugadorMiniLigaTO[];
  /** @description Equipo del rival */
  equipoAjeno?: JugadorMiniLigaTO[];
  /** @description Nombre de equipo Ajeno (del rival) */
  nEAjeno?: string;
  /** @description Nombre y apellido Ajeno (del rival) */
  nUAjeno?: string;
  /** @description Nombre de equipo Propio (usuario logueado) */
  nEProp?: string;
  /** @description Nombre y apellido (usuario logueado) */
  nUProp?: string;
  /** @description Camiseta propia */
  camisetaP?: string;
  /** @description Camiseta Ajena (rival) */
  camisetaA?: string;
  /** @description evitar esto. Usar 'estado' */
  status?: boolean;
}

/** @description página con PostTAsTO */
export interface PagePostTAsTO {
  objectList?: PostTAsTO[];
  /** Format: int32 */
  pageCount?: number;
  /** Format: int32 */
  currentPage?: number;
  hasNext?: boolean;
  hasPrevious?: boolean;
  pagerInfo?: PagerInfo;
  /** Format: int32 */
  objectCount?: number;
}
/** @description Chat de TDA y ML */
export interface PostTAsTO {
  /** Format: int32 */
  id?: number;
  descripcion?: string;
  /**
   * Format: int32
   * @deprecated
   * @description IGNORAR, siempre '1' o null. <br>sólo TDA! <br>El único estado que se muestra es el ACTIVO<br>Enum EEstadoPostForo:<li>ACTIVO(1)</li><li>EN_ABUSO(2)</li><li>ELIMINADO(3)</li>
   * @enum {integer}
   */
  idEstado?: 1;
  /**
   * Format: date-time
   * @description un Timestamp
   */
  fechaRealizacion?: string;
  /** @description Supongo que nombre y apellido */
  user?: string;
  /** @description sólo para TDA */
  apodo?: string;
  /** @description fecha formateada, formato "dd/MM '|' HH:mm" */
  fechaMostar?: string;
  fotoPerfil?: string;
  /** @description sólo para ML */
  camiseta?: string;
  /**
   * Format: int32
   * @description Si es el idUsuario (no es de participante)
   */
  idUsuario?: number;
}

export interface RequestGetChatMessages {
  idMiniLiga: number;
  paginaActual?: number;
  cantPorPagina?: number;
}

export interface RequestSaveChatMessages {
  idMiniLiga: number;
  mensaje: string;
  /** csv, ids de usuarios mencionados. Creo que se eliminó en responsive.<br>. Inserta Alertas Web (Notificaciones). */
  menciones?: string;
}
export interface ResponseGetChatMessages {
  /**
   * true / false.
   * @description Indica si hubo un error o no.
   */
  estado: boolean;
  /**
   * mensaje de error
   * @description si estado == false.
   */
  mensaje?: string;
  /**
   * código de error (opcional)
   * Format: int32
   * @description si estado == false.
   */
  codError?: number;
  page?: PagePostTAsTO;
  /**
   * Format: int32
   * @description datos de paginación.
   */
  paginaActual?: number;
  /**
   * Format: int32
   * @description datos de paginación.
   */
  cantPorPagina?: number;
  /** @description deprecated. siempre false. */
  tieneMensaje?: boolean;
  /** @description deprecated. siempre false. */
  tieneVideo?: boolean;
  /** @description ¿Innecesario? Indica que no hay un flag en el participante que dice que no quiere leer mensajes. */
  mostrarMensajes?: boolean;
}
export interface ResponseSaveChatMessages {
  /**
   * true / false.
   * @description Indica si hubo un error o no.
   */
  estado: boolean;
  /**
   * mensaje de error
   * @description si estado == false.
   */
  mensaje?: string;
  /**
   * código de error (opcional)
   * Format: int32
   * @description si estado == false.
   */
  codError?: number;
  /** @description Formato: "EEEEEEE dd 'de' MMMMM '|' HH:mm a" */
  fecha?: string;
  /** @description true */
  mensajeEnviado?: boolean;
  /** @description Nombre y apellido */
  usuario?: string;
  /** @description obvio */
  fotoPerfil?: string;
  /** @description obvio */
  camiseta?: string;
  /**
   * Format: int32
   * @description id del post recién creado.
   */
  idPost?: number;
}

export interface DatosFotoMLDTO {
  pathImagen?: string;
  idFotoPredefinida?: string;
}
export interface ResponseUploadFotoML extends ResponseBase {
  fotoML: DatosFotoMLDTO;
}
